import * as React from "react";
import { Link } from "react-router";
import { listArticles, searchArticles } from "./wiki-content";

const CATEGORY_LABEL: Record<string, string> = {
  rechtliches: "Rechtliches",
  massnahmen: "Maßnahmen",
  doku: "Dokumentation",
  quellen: "Quellen",
  sonstiges: "Sonstiges",
};

export function WikiIndexRoute() {
  const [query, setQuery] = React.useState("");
  const articles = React.useMemo(() => {
    return query.trim() ? searchArticles(query) : listArticles();
  }, [query]);

  const grouped = React.useMemo(() => {
    const map = new Map<string, typeof articles>();
    for (const a of articles) {
      const list = map.get(a.category) ?? [];
      list.push(a);
      map.set(a.category, list);
    }
    return Array.from(map.entries());
  }, [articles]);

  if (articles.length === 0 && !query) {
    return (
      <section className="space-y-4">
        <h1 className="text-3xl font-semibold">Wiki</h1>
        <p className="rounded-md bg-[color:var(--color-surface-elevated)] p-6 text-sm">
          Wiki-Inhalte werden geladen. Build-Bundle prüfen.
        </p>
      </section>
    );
  }

  return (
    <section className="space-y-6">
      <header>
        <h1 className="text-3xl font-semibold">Wiki</h1>
        <p className="text-sm text-neutral-600">
          Hitzeschutz-Wissen für Schule, Kita und Träger — rechtssicher dokumentiert.
        </p>
      </header>

      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Wiki durchsuchen …"
        className="h-12 w-full max-w-md rounded-md border border-[color:var(--color-border)] bg-white px-3"
      />

      {grouped.map(([category, items]) => (
        <article key={category}>
          <h2 className="mb-3 text-xl font-semibold">
            {CATEGORY_LABEL[category] ?? category}
          </h2>
          <ul className="space-y-2">
            {items.map((a) => (
              <li key={a.slug}>
                <Link
                  to={`/wiki/${a.slug}`}
                  className="flex items-baseline justify-between rounded-md border border-[color:var(--color-border)] bg-white p-3 hover:border-[color:var(--color-border-strong)]"
                >
                  <span className="font-medium">{a.title}</span>
                  {a.lastUpdated && (
                    <span className="text-xs text-neutral-500">{a.lastUpdated}</span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </article>
      ))}

      {articles.length === 0 && query && (
        <p className="text-sm text-neutral-500">Keine Treffer für „{query}“.</p>
      )}
    </section>
  );
}
